import { createQuery, type CreateQueryOptions } from '@tanstack/svelte-query';
import { client } from '../Client';
import type {
  RetrieveEternalChallengeStateResponse,
  RetrieveProjectResponse,
} from '$shared/api';
import { ProjectType } from '$shared/lib';
export const eternalChallengeQueryKey = ['eternal-challenge'] as const;

export function userEternalChallengeQuery(
  options?: Omit<
    CreateQueryOptions<RetrieveEternalChallengeStateResponse, Error>,
    'queryKey' | 'queryFn'
  >,
) {
  return createQuery({
    queryKey: eternalChallengeQueryKey,
    queryFn: () => client.eternal.retrieveEternalChallengeState(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
}

export function eternalChallengeProjectQuery(
  options?: Omit<
    CreateQueryOptions<RetrieveProjectResponse, Error>,
    'queryKey' | 'queryFn'
  >,
) {
  return createQuery({
    queryKey: ['eternal-challenge-project'],
    queryFn: () => client.projects.getProject({ type: ProjectType.ETERNAL }),
    ...options,
  });
}
